import { LazyLoad } from 'app/utils';

export const MaintenanceFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.MaintenanceFormPage,
);
